import styled from "styled-components"
import { getCssSizeValue, isStringEmpty } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Video from "@/components/common/Video"
import React, { useState } from "react"
import VideoControls from "@/components/Banners/SubPage/Components/VideoControls"
import GridContainer from "@/components/common/GridContainer"
import BannerCard from "@/components/Banners/SubPage/Components/BannerCard"
import AssetWrapper from "@/components/Banners/SubPage/Components/AssetWrapper"

const Wrapper = styled.section`
	overflow: hidden;
	position: relative;
	height: 100svh;
	width: 100%;
	display: flex;
	align-items: flex-end;
	padding-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-bottom: ${getCssSizeValue(48)};
	}
`

const CommonVideo = styled(Video)`
	overflow: hidden;
	position: relative;
	width: 100%;
	height: 100%;
`

const StyledGridContainer = styled(GridContainer)`
	position: relative;
	z-index: 3;
	align-items: end;

	transition: opacity 0.2s;

	&.hide {
		pointer-events: none;
		opacity: 0;
	}
`

export default function VideoWithButtonToStartFullScreenVideo({ data }) {
	const assetVideoUrl = data?.video?.url || ""
	const externalVideoUrl = data?.externalVideo?.url || ""

	const [isFullScreenVideoVisible, setIsFullScreenVideoVisible] = useState(false)

	const handleToggleFullScreenVideo = () => {
		setIsFullScreenVideoVisible((prev) => !prev)
	}

	return (
		<Wrapper>
			{!isStringEmpty(externalVideoUrl) && (
				<VideoControls handleToggleVideo={handleToggleFullScreenVideo} isVideoPlaying={isFullScreenVideoVisible} />
			)}
			<AssetWrapper className={`${isFullScreenVideoVisible ? "hide" : "show"} above`}>
				<CommonVideo src={assetVideoUrl} playing={!isFullScreenVideoVisible} resetOnPause={false} />
			</AssetWrapper>

			<AssetWrapper>
				<CommonVideo
					src={externalVideoUrl}
					playing={isFullScreenVideoVisible}
					resetOnPause={false}
					onClick={handleToggleFullScreenVideo}
					muted={false}
				/>
			</AssetWrapper>

			<StyledGridContainer className={`${isFullScreenVideoVisible ? "hide" : ""}`}>
				<BannerCard data={data} />
			</StyledGridContainer>
		</Wrapper>
	)
}
